import { CartCalendarItem } from '../admins-page/carts/assignment/calendar/CartCalendarItem';
import { cartServices } from 'src/services';
import { FailedToGetData, Loading } from '../_commons';
import { setAlertResponse } from 'src/store';
import { typeCartsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';
import { useParams } from 'react-router';

export const FreeCartsPage = () => {
    const params = useParams();
    //
    const [cartsDoc, setCartsDoc] = useState<typeCartsDoc | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const congregation = parseInt(params.congregation || '0');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    useEffect(() => {
        setIsLoading(true);
        cartServices.GetFree(congregation).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.cartsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCartsDoc(response.data.cartsDoc);
        });
    }, []);

    if (isLoading) {
        return <Loading mt={'120px'} />;
    }

    if (!cartsDoc) {
        return <FailedToGetData />;
    }

    return (
        <>
        {/* <H2 title={'CARRITOS'} /> */}
        <div className={isDarkMode ? 'bg-dark text-white' : ''}>
            {cartsDoc.points?.filter(p => !p.wasDeleted).map(point =>
                <div key={point.id}>
                    <CartCalendarItem
                        cartsDoc={cartsDoc}
                        hidePickupCartPoint={true}
                        month={new Date().getMonth()}
                        point={point}
                        readOnly={true}
                        setRefreshCounter={() => {}}
                        year={new Date().getFullYear()}
                    />
                </div>
            )}
            {new Date().getDate() > 27 &&
                cartsDoc.points?.filter(p => !p.wasDeleted).map(point =>
                    <div key={point.id}>
                        <CartCalendarItem
                            cartsDoc={cartsDoc}
                            hidePickupCartPoint={true}
                            month={(new Date().getMonth() + 1) % 12}
                            point={point}
                            readOnly={true}
                            setRefreshCounter={() => {}}
                            year={new Date().getMonth() === 11 ? new Date().getFullYear() + 1 : new Date().getFullYear()}
                        />
                    </div>
                )
            }
        </div>
        </>
    );
}
